// import react packages;
import React, { useContext } from "react";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// Import Polaris Components
import { LegacyCard as Card, BlockStack } from "@shopify/polaris";

// import helper
import { PrivateContext } from "lib/context";
import constant from "lib/constant/constant";

// import components
import WooCommerceConnect from "app/product/modules/provider/features/genric/wooCommerceConnect/wooCommerceConnect";

const VendorConnectWoocommerce = (prop) => {
  const { cms } = useContext(PrivateContext);
  const { setBanner } = prop;

  return (
    <>
      <Card title={cms("section.connect.title")}>
        <Card.Section>
          <BlockStack gap="2">{cms("section.connect.description")}</BlockStack>
          <br />
          <WooCommerceConnect setBanner={setBanner} />
        </Card.Section>
      </Card>
    </>
  );
};

export default withFeature(withErrorBoundary(VendorConnectWoocommerce), {
  feature: constant.PRODUCT_IMPORT_WOOCOMMERCE,
  // subFeature: constant.PRODUCT_IMPORT_WOOCOMMERCE,
});
